<template>
  <div class="container" @click="onCopy">
    <div class="content">
      <div class="label">{{ label }}</div>
      <div class="value">{{ value }}</div>
    </div>
    <div class="action">
      <cs-button />
      <span class="action-icon"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopyField',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  methods: {
    onCopy() {
      this.$copyText(this.value);

      this.$alert({
        type: 'ok',
        text: this.$t('link.copied'),
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  .container
    display: flex
    justify-content: space-between
    background-color: rgba(124,179,66,0.25)
    border: 1px solid rgba(255, 255, 255, 0.07)
    border-radius: 10px
    overflow: hidden
    cursor: pointer

  .content
    padding: 12px 10px 16px
    overflow: hidden

  .action
    width: 80px
    flex: none
    display: flex
    position: relative

    // TODO: @danealton реализовать возможность встраивать кнопки с подобные поля
    & .cs-button.primary
      width: 100% !important
      padding: 0
      border-radius: 0

  .action-icon
    width: 20px
    height: 20px
    flex: none
    display: block
    position: absolute
    top: 50%
    left: 50%
    background-image: url('~@/assets/svg/common/copy.svg')
    background-repeat: no-repeat
    background-position: center
    transform: translate(-50%, -50%)

  .label
    margin-bottom: 10px
    font-size: 14px
    line-height: 16px
    color: #7CB342

  .value
    font-size: 20px
    line-height: 24px
    color: #fff
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis
</style>
